module.exports = __webpack_public_path__ + "aj.no2.1e342d37.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/aj.no2.jpg
// module id = pp0k
// module chunks = 0